import React from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import LoginDefault from './LoginDefault';
import byDefault from './byDefault';

function LoginDefaultModal(props) {
  const {isOpen, toggle, redirect} = props;
  const LoginByDefault = byDefault(LoginDefault);

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} style={{borderBottom: 'none'}}></ModalHeader>
      <ModalBody style={{padding: '0px 25px 50px 25px'}}>
        <LoginByDefault redirect={redirect} />
      </ModalBody>
    </Modal>
  );
}

export default LoginDefaultModal;
